import { StanFilterValue } from '@/components/core-components/StanFilters/types';
import { CourseFan, CourseLesson, CourseModule } from '@/types/courses';

// ============================================================================
// API Data Models
// ============================================================================

export interface CourseAnalytics {
    course_name: string;
    store_id: string;
    store_type: 'linksite' | 'funnel';
    status: number;
    total_enrollment: number;
    total_lessons_completed: number;
    lessons_count: number;
    modules_count: number;
    lessons: CourseLesson[];
    modules: CourseModule[];
    overall_completion_rate: number;
    lessons_completion_rate: number[];
    lessons_names: string[];
    module_names: string[];
    module_grouping_length: number[];
}

export interface CourseFansResponse {
    data: CourseFan[];
}

export interface CourseEmailTemplateVariables {
    body: Array<{
        name: string;
        id: string;
        required: boolean;
    }>;
    subject: Array<{
        name: string;
        id: string;
        required: boolean;
    }>;
}

export interface CourseEmailTemplate {
    subject: string;
    email_template: string;
    default: {
        subject: string;
        body: string;
    };
    variables: CourseEmailTemplateVariables;
}

export interface CourseEmailTemplateResponse {
    course_mass_email: CourseEmailTemplate;
}

export interface CourseMetrics {
    totalEnrollment: number;
    overallCompletionRate: number;
    totalLessonsCompleted: number;
}

// ============================================================================
// Filter Types
// ============================================================================

export enum CourseFilterField {
    FAN_SINCE = 'fan-since',
    FAN_NAME = 'fan-name',
    FAN_EID = 'fan-eid',
    MODULE_ID = 'module-id',
    LESSON_ID = 'lesson-id',
}

// Vue-style filter structure for API calls
export interface CourseApiFilter {
    fieldName: CourseFilterField;
    operator: string;
    value: string;
    type: string;
    urlCode: string;
}

// StanFilters structure for UI
export interface CourseFilterValue extends StanFilterValue {
    id: CourseFilterField;
}

// ============================================================================
// Component Props
// ============================================================================

export interface CourseMetricsCardsProps {
    metrics: CourseMetrics;
}

export interface CourseUsersTableProps {
    courseId: string;
    analytics: CourseAnalytics | null;
}

export interface CourseMetricsSectionProps {
    analytics: CourseAnalytics;
}

export interface RetentionChartProps {
    analytics: CourseAnalytics;
}

export interface CourseEmailEditorProps {
    courseId: string;
    filteredUsersCount: number;
    totalUsersCount: number;
    pendingFanIds: string[];
    hasActiveFilters?: boolean;
    onCancel: () => void;
    onEmailSent: () => void;
}

// ============================================================================
// Utility Function Params
// ============================================================================

export interface UseCourseFansTableColumnsProps {
    showEmailOptions: boolean;
    courseId: string;
    onRefresh: () => void;
}

// ============================================================================
// Error Handling Types
// ============================================================================

export interface ErrorNotificationOptions {
    title: string;
    defaultMessage: string;
    sentryMessage: string;
    userFanId: number;
}
